import { ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewContainerRef, ViewEncapsulation } from '@angular/core';

import { InputConverterFunc } from '../../../inputConverter';
import { BaseComponent } from '../../base.component';

export interface ITab {
    name: string;
    active?: boolean;
    isVisible?: boolean;
}

export let TabConverter: InputConverterFunc<ITab> = (value: any) => {
    if (typeof value === 'string') { return JSON.parse(value) as ITab; }
    return value;
};

export let TabArrayConverter: InputConverterFunc<ITab[]> = (value: any) => {
    if (typeof value === 'string') { return JSON.parse(value) as ITab[]; }
    return value;
};
// TODO: Remove this. Applications should do tabs on their own.
@Component({
    encapsulation: ViewEncapsulation.ShadowDom,
    selector: 'mc-tabs-ng',
    styleUrls: ['../../sharedStyles/base.scss'],
    templateUrl: './tabs.component.html'
})
export class TabsComponent extends BaseComponent {
    get includeGoogleAnalytics() { return false; }

    @Output() readonly tabChanged: EventEmitter<ITab> = new EventEmitter();

    private _tabs: ITab[] = [];

    get tabs(): ITab[] {
        return this._tabs;
    }

    @Input()
    set tabs(value) {
        this._tabs = this.convertToTabArray(value);
        this.cdr.detectChanges();
    }

    @Input()
    get activeTab() { return this.tabs.find(t => t.active); }

    constructor(_vcr: ViewContainerRef, private readonly cdr: ChangeDetectorRef) {
        super(_vcr, true);
        this.registerEvent('tabchanged', this.tabChanged);
    }

    @Input()
    activateTab = (tab: string | ITab) => {
        if (typeof tab === 'string') {
            tab = this.tabs.find(t => t.name === tab);
        }
        const pt = tab;
        if (pt && this.activeTab.name !== pt.name) {
            this.tabs.forEach(t => {
                if (t.name !== pt.name) {
                    t.active = false;
                } else {
                    t.active = true;
                }
            });
            this.tabChanged.emit(this.activeTab);
            this.cdr.detectChanges();
        }
    }

    private convertToTabArray(value: any) {
        let tabArray: ITab[] = [];

        if (typeof value === 'string') {
            tabArray = JSON.parse(value) as ITab[];
        } else {
            tabArray = value;
        }

        tabArray.forEach((tab) => {
            if (tab.isVisible === undefined) {
                tab.isVisible = true;
            }

            if (tab.active === undefined) {
                tab.active = false;
            }
        });

        return tabArray;
    }
}
